<template>
  <div class="pa-4">
<!-- پاپ‌آپ ویرایش فروشگاه -->
<AddOnlineStore
  v-model="isShowEditModal"
  :isEdit="true"
  :storeId="selectedStoreId"
  @refresh="fetchStores"
/>

    <!-- پاپ‌آپ تنظیمات قیمت -->
    <custom-popup
      v-model="isShowPricingModal"
      :cons="{title:'تنظیمات قیمت', icon:'cash'}"
      :loading.sync="loading"
      hide-confirm
      max-width="900"
      persistent
    >
      <StorePricingSettings
        v-if="selectedStoreId"
        :store_id="selectedStoreId"
        :isEdit="true"
        @close="isShowPricingModal = false"
        @saved="onPricingSaved"
      />
    </custom-popup>

    <!-- پاپ‌آپ افزودن فروشگاه -->
     
    <AddOnlineStore
      v-model="isShowAddStore"
      @refresh="fetchStores"
    />

    <!-- جدول لیست فروشگاه‌ها -->
    <v-card outlined class="rounded-lg pa-6">

      <vue-table
        :data="tableData"
        :headers="headers"
        :loading="loading"
        @change="onTableChange"
      >
        <template v-slot:filters="{ props,perPage }">
          <v-row no-gutters class="pa-2">
            <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select
              v-model="props.length"
              :items="perPage"
              class="rounded-lg"
              dense
              hide-details
              label="تعداد در صفحه"
              outlined
              @change="() => onPagination(props)"
            />
          </v-col>

            <v-col cols="12" sm="4" class="pa-2">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                label="جستجو در فروشگاه‌ها..."
                outlined
                dense
                hide-details
              />
            </v-col>
          <v-col class="pa-2" cols="12" lg="2" md="2">
            <v-select
              v-model="props.active"
              :items="ActiveOptions"
              label="وضعیت"
              dense
              hide-details
              outlined
              clearable
              class="rounded-lg"
              @change="() => onPagination(props)"
            />
          </v-col>
        <v-col class="pa-2" cols="12" lg="2" md="2">
          <v-select
            v-model="props.type"
            :items="typeOptions"
            label="نوع فروشگاه"
            dense
            hide-details
            outlined
            clearable
            class="rounded-lg"
            @change="() => onPagination(props)"
          />
        </v-col>
          <!-- <v-col class="pa-2" cols="12" lg="2" md="2">
          <v-select
            v-model="props.connected"
            :items="connectedOptions"
            label="نوع اتصال"
            dense
            hide-details
            outlined
            clearable
            class="rounded-lg"
            @change="() => onPagination(props)"
          />
        </v-col> -->
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{ item.index + 1 }}
        </template>

        <!-- نوع فروشگاه با آیکون اختصاصی -->
        <template v-slot:type="{ item }">
          <div class="d-flex align-center justify-center">
            <v-icon small class="ml-1" :color="getStoreColor(item.type)">
              {{ getStoreIcon(item.type) }}
            </v-icon>
            <span>{{ getStoreTypeName(item.type) }}</span>
          </div>
        </template>

        <!-- اطلاعات اتصال -->
        <template v-slot:credential="{ item }">
          <span dir="ltr" class="font-weight-medium">
            {{ getCredentialDisplay(item) }}
          </span>
        </template>

        <!-- وضعیت -->
      <template v-slot:active="{ item }">
        <v-chip
          small
          :color="item.active ? 'success lighten-5' : 'grey lighten-3'"
          :text-color="item.active ? 'success darken-2' : 'grey darken-2'"
          class="font-weight-bold"
        >
          <v-icon left x-small>{{ item.active ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
          {{ item.active ? 'فعال' : 'غیرفعال' }}
        </v-chip>
      </template>
              <!-- وضعیت -->
      <template v-slot:connected="{ item }">
        <v-chip
          small
          :color="item.connected ? 'success lighten-6' : 'grey lighten-6'"
          :text-color="item.connected ? 'success darken-4' : 'grey darken-4'"
          class="font-weight-bold"
        >
          <v-icon left x-small>{{ item.connected ? 'mdi-link-lock' : 'mdi-link-off' }}</v-icon>
          {{ item.connected ? 'متصل' : 'منفصل' }}
        </v-chip>
      </template>


        <!-- تاریخ -->
        <template v-slot:created_at="{ item }">
          {{ jalalian ? jalalian(item.created_at) : item.created_at }}
        </template>

        <template v-slot:actions="{ item }">
          <action-buttons :data="item" :meta="metabutton(item)" />
        </template>
      </vue-table>
    </v-card>
  </div>
</template>

<script>
import AddOnlineStore from "./AddOnlineStore.vue";
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";

export default {
  name: "OnlineStoresTab",
  components: { AddOnlineStore, ActionButtons },
  data() {
    return {
      isShowEditModal: false,
      editingStore: null,  
      selectedStoreId: null,
      isShowPricingModal: false,
      isShowAddStore: false,
      loading: false,
      tableData: { data: [], current_page: 1, per_page: 30, total: 0 },
      headers: [
        { text: "ردیف", value: "index", align: "center", width: "70px" },
        { text: "نوع فروشگاه", value: "type", align: "center" },
        { text: "نام فروشگاه", value:"title", align:"center"},
        { text: "اطلاعات اتصال", value: "credential", align: "center" },
        { text: "وضعیت", value: "active", align: "center" },
        // { text: "اتصال", value: "connected", align: "center" },
        { text: "تاریخ ثبت", value: "created_at", align: "center" },
        { text: "عملیات", value: "actions", align: "center", width: "120px" }
      ],
        ActiveOptions: [
        { text: "همه", value: null },
        { text: "فعال", value: 1 },
        { text: "غیرفعال", value: 0 },
      ],
      connectedOptions:[
        { text: "همه", value: null },
        { text: "متصل", value: 1 },
        { text: "منفصل", value: 0 },

      ],
      typeOptions: [
      { text: "همه", value: null },
      { text: "دیجیکالا", value: "digikala" },
      { text: "ووکارمس", value: "woocommerce" },
      { text: "فروشگاه فیزیکی", value: "physical_store" },
      { text: "دیوار", value: "divar" },

    ],

      tableParams: { page: 1, length: 30, search: "", active:null,type:null, connected:false }
    };
  },
  mounted() { this.fetchStores(); },
  methods: {
    openEditModal(item) {
    this.editingStore = item;
    this.selectedStoreId =item.id;
    this.isShowEditModal = true;
  },
  openPricingModal(item){

  },
  metabutton(item) {
    return {
      buttons: [            
        { name: "edit", label: "ویرایش", icon: "pencil", class: "btn-edit border-2 rounded-pill",action: () => this.openEditModal(item) },
        { name: "pricing", label: "قیمت", icon: "calculator", class: "btn-show border-2 rounded-pill", action: () => this.openPricingModal(item) },
        { name: "delete", label: "حذف", icon: "trash-can", class: "btn-delete border-2 rounded-pill", action: () => this.deleteStore(item) }
      ]
    };
  },
    getStoreIcon(type) {
      const icons = { digikala: "mdi-shopping", woocommerce: "mdi-cart-outline", divar: "mdi-domain", physical_store: "mdi-store" };
      return icons[type] || "mdi-store-cog";
    },
    getStoreColor(type) {
      const colors = { digikala: "red darken-1", woocommerce: "deep-purple darken-1", divar: "orange darken-2", physical_store: "blue darken-1" };
      return colors[type] || "grey";
    },
    getStoreTypeName(type) {
      const names = { digikala: "دیجی‌کالا", woocommerce: "ووکامرس", divar: "دیوار", physical_store: "فیزیکی" };
      return names[type] || type;
    },
    getCredentialDisplay(item) {
      if (!item.connection) return "-";
      return item.type === 'woocommerce' ? item.connection.base_url : "مشاهده تنظیمات";
    },
    async fetchStores() {
      this.loading = true;
      try {
        const res = await this.$api.get(`v1/store`, { params: this.tableParams });
        if (res.data?.status) {
          this.tableData = res.data.data;
        }
      } catch (err) { this.$toast?.error?.("خطا در دریافت لیست فروشگاه‌ها"); }
      finally { this.loading = false; }
    },
    onTableChange(params) { this.tableParams = params; this.fetchStores(); },
    onPricingSaved() { this.isShowPricingModal = false; },
    async deleteStore(item) {
            const confirm = await this.$modal.yesNo("آیا از حذف این فروشگاه اطمینان دارید؟");
      if (!confirm) return;

      this.loading = true;
      try {
        await this.$api.delete(`v1/store/${item.id}`);
        this.$toast?.success?.("با موفقیت حذف شد");
        this.fetchStores();
      } catch (err) { this.$toast?.error?.("خطا در حذف"); this.loading=false;}
      finally{
      this.loading=false;
      }
    }
  }
};
</script>
